module.exports = __webpack_public_path__ + "assets/img/choice copy.98caba2a.svg";